var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_5954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_5954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1136_5954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.07812,
    y: 2,
    width: 17.8447,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1136_5954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4707 15.4834H6.08008V14.0454H19.4707V15.4834Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85352 2.8335H11.9862V11.5734H9.85352V2.8335Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05078 4.28882H8.26206V11.5042C8.19436 11.5506 8.15277 11.6026 8.10845 11.606C6.05109 11.7626 6.05109 11.7619 6.05109 9.40996L6.05078 4.28882Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8093 18.0518V19.5001H6.06836V18.0518H15.8093Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7375 11.5184H13.6191V6.98633H15.7375V11.5184Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlTransaction);
export default __webpack_public_path__ + "static/media/bl_transaction.020d97c7040d150ebbf83e8639e90c1a.svg";
export { ForwardRef as ReactComponent };